import type { ReactNode } from 'react'
import usePulseReveal from './usePulseReveal'

interface PulseRevealProps {
  children: ReactNode
  trigger?: unknown
}

const PulseReveal = ({ children, trigger }: PulseRevealProps) => {
  const { isPulse, frameRef } = usePulseReveal(trigger)

  if (!isPulse) return <>{children}</>

  return <div ref={frameRef}>{children}</div>
}

export default PulseReveal
